import { render } from "./PostOptIn.vue?vue&type=template&id=1ecfbd78&scoped=true"
import script from "./PostOptIn.vue?vue&type=script&lang=js"
export * from "./PostOptIn.vue?vue&type=script&lang=js"

import "./PostOptIn.vue?vue&type=style&index=0&id=1ecfbd78&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1ecfbd78"]])

export default __exports__